import React, { useState, useEffect } from 'react';
import {EditOutlined} from '@ant-design/icons';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import { Button, Modal, Form, Input, Select } from 'antd';
// import moment from 'moment';

const { Option } = Select;

const SalesUpdateForm = ({ visible, onCreate, onCancel, record }) => {

    let payment = record
    const [form] = Form.useForm();
    const [customerData, setCustomerData] = useState([])
    const [salesSalesID] = useState(payment.SalesID)
    const [salesCustomerID]=useState(payment.CustomerName)
    const [salesPayment]=useState(payment.PaymentMethod)
    const [salesDate] = useState(payment.SalesDate)

    useEffect(() => {
      const loadCustomerData = async () => {
        const customerResponse = await fetch(`${FetchVariable.Heroku}/customer`)
        const customerData = await customerResponse.json()

        setCustomerData(customerData)
      }
      loadCustomerData();
    }, []);
    
  return (
    <Modal
      visible={visible}
      title="Update Sales"
      okText="Update"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="AuctionUpdate"
        initialValues={{
            SalesID:salesSalesID,
            CustomerID: salesCustomerID,
            PaymentMethod: salesPayment,
            SalesDate: salesDate,
        }}
      >
        <Form.Item
          name="SalesID"
          label="Sales ID"
        >
            <Input disabled/>
        </Form.Item>
        <Form.Item name='CustomerID' label="Customer Name" >
            <Select
            showSearch
            placeholder="Select a customer"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {customerData?.map(customer => <Option value={customer.CustomerID} key={customer.CustomerID}>{customer.CustomerName}</Option>)}
            </Select>
        </Form.Item>
        <Form.Item name="PaymentMethod" label="Payment Method">
            <Select >
                <Option value="Cash">Cash</Option>
                <Option value="Check">Check</Option>
                <Option value="N/A">N/A</Option>
              </Select>
        </Form.Item>
        {/* <Form.Item name='SalesDate' label="Sales Date">
            <DatePicker format={moment().format("YYYY-MM-DD")}/>
        </Form.Item> */}
      </Form>
    </Modal>
  );
};

const SalesUpdate = (props) => {
  const [visible, setVisible] = useState(false);
  const onCreate = (values) => {
    props.updateSales(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}

        icon={<EditOutlined />}
      >
        
      </Button>
      <SalesUpdateForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
        record={props.record}
      />
    </div>
  );
};

export default SalesUpdate;